import type { SettlementPendingInspection } from "./types.js";

const heading = "[검수 대기 내역 · 이번 정산 제외]";
const ending = "※ 위 수량은 검수 완료 후 정산 조건을 충족하면 반영됩니다.";

/** Only replace our bounded appendix; preserve the worker's edited payment text. */
export function withSettlementPendingInspections(message: string, items: SettlementPendingInspection[]) {
  const start = message.indexOf(`\n\n${heading}\n`);
  const end = start < 0 ? -1 : message.indexOf(ending, start);
  const body = start >= 0 && end >= 0
    ? message.slice(0, start) + message.slice(end + ending.length)
    : message;
  const groups = new Map<string, { name: string; tasks: Map<string, { name: string; quantity: number }> }>();
  for (const item of items) {
    if (item.quantity <= 0) continue;
    const group = groups.get(item.projectId) ?? { name: item.projectName, tasks: new Map() };
    const task = group.tasks.get(item.subtaskId) ?? { name: item.subtaskName, quantity: 0 };
    task.quantity += item.quantity;
    group.tasks.set(item.subtaskId, task);
    groups.set(item.projectId, group);
  }
  if (!groups.size) return body;
  const lines = [...groups].sort((a, b) => a[1].name.localeCompare(b[1].name, "ko") || a[0].localeCompare(b[0]))
    .flatMap(([, group]) => [`「${group.name}」`, ...[...group.tasks].sort((a, b) => a[1].name.localeCompare(b[1].name, "ko") || a[0].localeCompare(b[0]))
      .map(([, task]) => `• ${task.name}: ${task.quantity.toLocaleString("ko-KR")}개`)]);
  return `${body}\n\n${heading}\n${lines.join("\n")}\n${ending}`;
}
